import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(iteratee);

var PREVIOUS = Symbol('previous');
var NEXT = Symbol('next');
export var LinkedList = function LinkedList() {
  return {
    head: null,
    tail: null
  };
}; // 在链表中加入节点

export function insert(list, tarNode) {
  var refNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var previous = refNode ? refNode[PREVIOUS] : list.tail;
  tarNode[NEXT] = refNode;
  tarNode[PREVIOUS] = previous;
  previous ? previous[NEXT] = tarNode : list.head = tarNode;
  refNode ? refNode[PREVIOUS] = tarNode : list.tail = tarNode;
  return tarNode;
} // 从链表中移除节点

export function remove(list, node) {
  node[PREVIOUS] ? node[PREVIOUS][NEXT] = node[NEXT] : list.head = node[NEXT];
  node[NEXT] ? node[NEXT][PREVIOUS] = node[PREVIOUS] : list.tail = node[PREVIOUS];
} // 遍历链表

export var each = function each(list) {
  return function (callback) {
    var cur = list.head;
    var next;

    while (cur !== null) {
      next = cur[NEXT];
      callback(cur);
      cur = next;
    }
  };
}; // 从begin迭代到end

export var iterate = function iterate(begin) {
  var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (callback) {
    for (; begin !== end; begin = reverse ? begin[PREVIOUS] : begin[NEXT]) {
      callback(begin);
    }
  };
};
export function iteratee(list) {
  var cur, next;
  return _regeneratorRuntime.wrap(function iteratee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          cur = list.head;

        case 1:
          if (!(cur !== null)) {
            _context.next = 8;
            break;
          }

          next = cur[NEXT];
          _context.next = 5;
          return cur;

        case 5:
          cur = next;
          _context.next = 1;
          break;

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
} // 判断节点1是否在节点2的前面

export function isBefore(node1, node2) {
  for (; node2 && node2 !== node1; node2 = node2[NEXT]) {
    ;
  }

  return node2 === null;
} // 通过遍历生成一个链表

export function generate(foreach) {
  var list = LinkedList();
  foreach(function (item) {
    return insert(list, item);
  });
  return list;
}